export default "__VITE_ASSET__eef97608__"